import rest from '@modules/rest'
import { getEmployeeInfoSchema } from '@services/systemField'
import { mapCustomFieldValues } from '@convenia/common-organisms/SystemFields/helpers'

export const getAdditionalSection = async (getters) => {
  const employeeId = getters.getEmployeeUuid
  const companyId = getters.getCompanyUuid

  const [ err, fields ] = await getEmployeeInfoSchema({
    employeeId,
    companyId,
    area: 'additional.additional'
  })

  const [ section ] = fields || []

  return [ err, section ]
}

export const updateAdditionalInfo = async (data, params) => {
  try {
    const { employeeId, companyId, schema, sectionId } = params
    const url = `/employees/proxy/companies/${companyId}/employees/${employeeId}/sections/${sectionId}/custom-field-values/employee`
    const body = {
      custom_fields: mapCustomFieldValues({
        data,
        schema,
        sectionId,
      })
    }

    await rest.put(url, { body })

    return [ null ]
  } catch (err) {
    return [ err ]
  }
}
